import { addClassNamesToElement } from '@lexical/utils'
import {
  LexicalEditor,
  EditorConfig,
  LexicalNode,
  $applyNodeReplacement,
  ElementNode,
  SerializedElementNode,
  NodeKey
} from 'lexical'

export class TableWrapperNode extends ElementNode {
  constructor(key?: NodeKey) {
    super(key)
  }

  static getType(): string {
    return 'tablewrapper'
  }

  static clone(node: TableWrapperNode): TableWrapperNode {
    return new TableWrapperNode(node.getKey())
  }

  static importJSON(serializedNode: SerializedElementNode): TableWrapperNode {
    return new TableWrapperNode()
  }

  exportJSON(): SerializedElementNode {
    return {
      ...super.exportJSON(),
      type: TableWrapperNode.getType()
    }
  }

  updateDOM(
    _prevNode: unknown,
    _dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    return false
  }

  createDOM(config: EditorConfig, _editor: LexicalEditor): HTMLElement {
    const dom = document.createElement('div')
    addClassNamesToElement(dom, config.theme.tableWrapper)
    return dom
  }

  canIndent() {
    return false
  }

  isInline(): boolean {
    return false
  }
}

export const $createTableWrapperNode = () => {
  return $applyNodeReplacement(new TableWrapperNode())
}

export const $isTableWrapperNode = (
  node: LexicalNode | null
): node is TableWrapperNode => {
  return node instanceof TableWrapperNode
}
